import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthService {

  constructor(private keycloakService: KeycloakService) { }

  async login(): Promise<void> {
    await this.keycloakService.login({
      redirectUri: this.getAdminBaseUrl()
    });
  }

  async logout(): Promise<void> {
    await this.keycloakService.logout();
  }

  async isAuthenticated(): Promise<boolean> {
    return await this.keycloakService.isLoggedIn();
  }

  async getToken(): Promise<string | null> {
    const isLoggedIn = await this.isAuthenticated();

    if (!isLoggedIn) {
      return null;
    }

    // Ottieni il token direttamente da Keycloak
    return await this.keycloakService.getToken();
  }

  async getDecodedToken(): Promise<any | null> {
    try {
      const token = await this.getToken();

      if (!token) {
        // console.warn('Nessun token trovato');
        return null;
      }

      const tokenParts = token.split('.');
      if (tokenParts.length !== 3) {
        console.error('Formato token non valido');
        return null;
      }

      return JSON.parse(atob(tokenParts[1]));
    } catch (error) {
      console.error('Errore durante la decodifica del token:', error);
      return null;
    }
  }

  async getAuthorizations(): Promise<any | null> {
    const token = await this.getDecodedToken();
    return token?.authorizations || null;
  }

  async getRole(): Promise<string | null> {
    const authorizations = await this.getAuthorizations();
    return authorizations?.role || null;
  }

  getAdminBaseUrl(): string {
    return window.location.origin + '/' + environment.adminPath;
  }

  isAdminUrl(): boolean {
    return window.location.href.startsWith(this.getAdminBaseUrl()) && !window.location.href.startsWith(this.getAdminBaseUrl() + "/prov/");
  }

}
